const timelineElements = [
  {
    id: 1,
    title: "Alternance - Développeur Full Stack",
    location: "Elcimaï, Melun",
    mission: "Conception et développement de nouvelles fonctionnalités, correction des anomalies au sein d'une solution bancaire basée sur Spring et React JS",
    secondMission: "Mise en place et réalisation de tests de charge avec Locust (Python)",
    thirdMission: "Proof of Concept : rendu dynamique de composants React à partir d'un schéma JSON généré par GrapesJS",
    fourthMission: "Implémentation de la réglementation VOP (Verification of Payee)",
    date: "09/2024 - 09/2026",
    icon: "work",
  },
  {
    id: 2,
    title: "Master Ingénierie du Web",
    location: "ESGI, Paris",
    descritpion: "",
    date: "2024 - 2026",
    icon: "school",
  },
  {
    id: 3,
    title: "Formation - Développeur Java / Angular",
    location: "Wild Code School",
    mission: "Formation intensive en développement Java et Angular",
    date: "15/04/2024 - 12/07/2024",
    icon: "school",
  },
  {
    id: 4,
    title: "Master Ingénierie du Web",
    location: "ESGI, Paris",
    descritpion: "",
    date: "09/2023 - 11/2023",
    icon: "school",
  },
  {
    id: 5,
    title: "Alternance - Développeur Full Stack",
    location: "Bucares, Évry-Courcouronnes",
    mission: "Réalisation d'une application web en utilisant le framework Spring et diverses bibliothèques JS (React JS, Redux, Axios) en suivant la méthodologie Scrum",
    secondMission: "Réalisation d'un Proof of Concept en utilisant le framework Spring et diverses bibliothèques JS (React JS, Redux, Axios)",
    thirdMission: "Optimisation SEO d'un site web",
    date: "09/2022 - 09/2023",
    icon: "work",
  },
  {
    id: 6,
    title: "Licence professionnelle Métiers de l'Informatique Applications Web",
    location: "Université d'Évry, Évry-Courcouronnes",
    descritpion: "Mention Bien",
    date: "2022 - 2023",
    icon: "school",
  },
  {
    id: 7,
    title: "Stage - Développeur Web",
    location: "Bucares, Évry-Courcouronnes",
    mission: "Création de sites internet via un outil de gestion",
    secondMission: "Développement en JSON",
    date: "06/2021 - 07/2021",
    icon: "work",
  },
  {
    id: 8,
    title: "BTS Systèmes Numériques option Informatique et Réseaux",
    location: "Lycée Edmond Michelet, Arpajon",
    descritpion: "",
    date: "2020 - 2022",
    icon: "school",
  },
  {
    id: 9,
    title: "DUT Génie Électrique et Informatique Industrielle",
    location: "IUT d'Évry, Évry-Courcouronnes",
    descritpion: "",
    date: "2019 - 2020",
    icon: "school",
  },
  {
    id: 10,
    title: "BAC Sciences et Technologies de l'Industrie et du Développement Durable",
    location: "Lycée Georges Brassens, Évry-Courcouronnes",
    descritpion: "Mention Assez Bien",
    date: "2018 - 2019",
    icon: "school",
  },
];

export default timelineElements;
